<template>
  <div class="open">
    <div v-if="codeShow">
      <van-overlay :show="codeShow">
        <div class="wrapper">
          <van-loading size="54px" vertical>{{ $t('message.loading') }}...</van-loading>
        </div>
      </van-overlay>
    </div>
    <div v-else>
      <div class="login_info_input">
        <van-form ref="form">
          <!-- <van-field
            v-model="phoneInfo.phone"
            type="number"
            label="+86"
            :placeholder="$t('message.login.please_phone')"
            show-word-limit
            :rules="telRules"
          /> -->
          <VuePhoneNumberInput
            v-model="phone"
            @update="validate"
            :translations="translations"
            class="phoneNumber"
            :preferred-countries="['CN', 'US', 'CA', 'TH', 'KH', 'PT', 'MY', 'JP']"
          />

          <!-- 请输入验证码 -->
          <van-field
            class="sms"
            v-model="phoneInfo.smsCode"
            center
            :placeholder="$t('message.login.enter_code')"
          >
            <button
              slot="button"
              :disabled="!countdown"
              :class="[countdown ? 'reg_active' : 'reg_disActive']"
              @click="getCode"
              type="text"
            >
              <span v-if="countdown">{{ text }}</span>
              <span v-if="!countdown">{{ text }} ({{ count }})</span>
            </button>
          </van-field>
        </van-form>
      </div>
      <div class="login_phone_btn">
        <van-button
          round
          v-if="this.phoneInfo.phone === '' || this.phoneInfo.phone === undefined"
          disabled
          >{{ $t('message.login.please_phone') }}</van-button
        >
        <van-button round v-else @click="submitPhone" v-preventReClick="3000">{{
          $t('message.login.sign')
        }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import 'vue-tel-input/dist/vue-tel-input.css'
const defaultPhone = Object.freeze({
  phone: '',
  smsCode: '',
  accessToken: '',
  openId: '',
  mobile: ''
})
import { setCookie, clearCookie } from '@/utils/cookie'
import { getSms, wechatPhone, wechatLogin } from '@/api/login'
import { Toast } from 'vant'
import { getCookie } from '@/utils/cookie'
export default {
  name: 'Open',
  computed: {
    code() {
      return this.$route.query.code
    }
  },
  components: {
    VuePhoneNumberInput
  },
  data() {
    return {
      countdown: true,
      count: '',
      text: this.$t('message.login.send_code'),
      codeShow: true,
      accessToken: '',
      phone: '',
      phoneInfo: { ...defaultPhone },
      openId: '',
      telRules: [
        {
          required: true,
          message: this.$t('message.login.phone_null'),
          trigger: 'onBlur'
        },
        {
          // 自定义校验规则
          validator: (value) => {
            return /0?(13|14|15|17|18|19)[0-9]{9}/.test(value)
          },
          message: this.$t('message.login.correct_phone'),
          trigger: 'onBlur'
        }
      ]
    }
  },
  created() {
    this.login()
    if (sessionStorage.getItem('lang') == 'zhcn') {
      this.translations = {
        countrySelectorLabel: '国家',
        phoneNumberLabel: '手机号码'
      }
    } else {
      this.translations = {}
    }
  },
  methods: {
    validate(val) {
      this.phoneInfo.mobile = val.formatNational
      this.phoneInfo.phone = val.formattedNumber
    },
    async submitPhone() {
      if (this.phoneInfo.smsCode === '') {
        Toast.fail(this.$t('message.login.enter_code'))
      } else {
        if (sessionStorage.getItem('organizationId')) {
          this.phoneInfo.organizationId = sessionStorage.getItem('organizationId')
        } else {
          this.phoneInfo.organizationId = 0
        }
        const { data: res } = await wechatPhone(this.phoneInfo)
        if (res.resultCode === 500) {
          Toast.fail(res.message)
        } else {
          this.$toast({
            duration: 1000,
            message: this.$t('message.login.login_suc')
          })
          sessionStorage.setItem('token', res.data.token)
          sessionStorage.setItem('userId', res.data.apiUser.id)
          sessionStorage.setItem('phone', res.data.apiUser.phone)
          sessionStorage.setItem('userName', res.data.apiUser.nickName)
          setCookie('userId', res.data.apiUser.id, 60)
          setCookie('token', res.data.token, 60)
          setTimeout(() => {
            this.$toast({
              duration: 1000,
              message: this.$t('message.login.page_jump')
            })
          }, 1000)
          setTimeout(() => {
            // var u = navigator.userAgent
            // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
            // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
            // if (isiOS == true) {
            //   this.$router.go(-4)
            // } else if (isAndroid == true) {
            //   this.$router.go(-5)
            // }

            this.$router.push('/')
          }, 2000)
        }
      }
    },
    async getCode() {
      const TIME_COUNT = 60
      if (
        this.phoneInfo.phone === '' ||
        this.phoneInfo.phone == undefined ||
        this.phoneInfo.phone == 'undefined'
      ) {
        Toast.fail(this.$t('message.login.please_phone'))
      } else {
        const { data: res } = await getSms({ phone: this.phoneInfo.phone })
        if (res.resultCode === 200) {
          Toast.success(this.$t('message.login.sent_succ'))
          if (!this.timer) {
            this.count = TIME_COUNT
            this.countdown = false
            this.text = this.$t('message.login.resend')
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.countdown = true
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
        } else {
          Toast.fail(this.$t('message.login.fsiled_send'))
        }
      }
    },
    async login() {
      const { data: res } = await wechatLogin({ code: this.code })
      if (res.resultCode === 200) {
        if (res.data.code === 10240) {
          this.$toast({
            duration: 1000,
            message: this.$t('message.login.login_suc')
          })
          sessionStorage.setItem('token', res.data.token)
          sessionStorage.setItem('userId', res.data.apiUser.id)
          sessionStorage.setItem('phone', res.data.apiUser.phone)
          sessionStorage.setItem('userName', res.data.apiUser.nickName)
          setCookie('userId', res.data.apiUser.id, 60)
          setCookie('token', res.data.token, 60)
          setTimeout(() => {
            this.$toast({
              duration: 1000,
              message: this.$t('message.login.page_jump')
            })
          }, 500)
          setTimeout(() => {
            // var u = navigator.userAgent
            // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
            // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
            // if (isiOS == true) {
            //   this.$router.go(-4)
            // } else if (isAndroid == true) {
            //   this.$router.go(-5)
            // }

            this.$router.push('/')
            // this.$router.go(-5)
          }, 1000)
        } else if (res.data.code === 10500) {
          this.codeShow = false
          this.phoneInfo.openId = res.data.openId
          this.phoneInfo.accessToken = res.data.accessToken
        }
      } else {
        this.$toast.fail(res.message)
        clearCookie('token')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.open {
  width: 100%;

  .login_info_input {
    width: 100%;
    // overflow: hidden;
    margin: 20px 0;
    .phoneNumber {
      width: 300px;
      margin: 0 auto;
    }
    .van-cell {
      margin: 20px auto 0 auto;
      width: 260px;
      background-color: #f6f6f6;
      border-radius: 32px;

      /deep/.van-field__label {
        width: 40px;
        text-align: center;
        color: #1a1a1a;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  .login_phone_btn {
    width: 100%;
    display: flex;
    margin: 50px 0 0 0;
    justify-content: center;
    align-items: center;

    /deep/ .van-button {
      width: 260px;
      height: 42px;
      box-sizing: border-box;
      text-align: center;
      border: none;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      background: #3562ff;
    }

    /deep/ .van-button--disabled {
      color: #999999;
      background: #ededed;
    }
  }

  .wrapper {
    margin: 8rem auto;
  }

  .sms {
    button {
      background: none;
      border: none;
    }

    .reg_active {
      color: #3562ff;
    }

    .reg_disActive {
      color: #999;
    }
  }
}
</style>
